import React from 'react';
import styled from 'styled-components';
var Inner = styled.div.withConfig({
  displayName: "Collapsible__Inner",
  componentId: "sc-9gwmdy-0"
})(["display:block;"]);
export var Collapsible = function Collapsible(props) {
  return React.createElement(Inner, null, props.children);
};